export default function toObjectArray(arrayToTransform, keyName, valueName) {
  const objectArray = [];

  Object.keys(arrayToTransform).forEach((key) => {
    objectArray.push({
      [keyName]: key,
      [valueName]: arrayToTransform[key],
    });
  });

  return objectArray;
}
